export default __webpack_public_path__ + "static/media/rounded-guide.5e706899.png";